/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ g: NonNullable<unknown> }} Gaz_ConsoInputs */



/**
* | output |
* | --- |
* | "Gas: {g} m³" |
*
* @param {Gaz_ConsoInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const gaz_conso = /** @type {((inputs: Gaz_ConsoInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gaz_ConsoInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Gas: ${i?.g} m³`)
	return /** @type {LocalizedString} */ (`Gaz : ${i?.g} m³`)
});